import Get from '../services/Get';
import Post from '../services/Post';
import Put from '../services/Put';
import Delete from '../services/Delete';

import { nexcareVersion } from '../config/serviceConfig';

// Remark
const postDataRemark = (data, token) => Post(`/${nexcareVersion}/nexcare/remark`, data, token);
const putDataRemark = (id, data, token) => Put(`/${nexcareVersion}/nexcare/remark/${id}`, data, token);
const deleteDataRemark = (id, data, token) => Delete(`/${nexcareVersion}/nexcare/remark/${id}`, data, token);

// Root Cause
const getInitiateRootCause = (token) => Get(`/${nexcareVersion}/nexcare/remark/root-cause/initiate`, token);
const getListRootCause = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/remark/root-cause?page=${page}&limit=${limit}`, token);

// Priority
const getInitiatePriority = (token) => Get(`/${nexcareVersion}/nexcare/remark/priority/initiate`, token);
const getListPriority = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/remark/priority?page=${page}&limit=${limit}`, token);

// Document Header
const getInitiateDocumentHeader = (token) => Get(`/${nexcareVersion}/nexcare/remark/document-header/initiate`, token);
const getListDocumentHeader = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/remark/document-header?page=${page}&limit=${limit}`, token);

// KMS Feedback
const getInitiateKmsFeedback = (token) => Get(`/${nexcareVersion}/nexcare/remark/kms-feedback/initiate`, token);
const getListKmsFeedback = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/remark/kms-feedback?page=${page}&limit=${limit}`, token);

// Ticket Feedback
const getInitiateTicketFeedback = (token) => Get(`/${nexcareVersion}/nexcare/remark/feedback/initiate`, token);
const getListTicketFeedback = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/remark/feedback?page=${page}&limit=${limit}`, token);

// Channel Note
const getInitiateChannelNote = (token) => Get(`/${nexcareVersion}/nexcare/remark/channel/initiate`, token);
const getListChannelNote = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/remark/channel?page=${page}&limit=${limit}`, token);

// Automatic Message
const getInitiateAutomaticMessage = (token) => Get(`/${nexcareVersion}/nexcare/remark/default-message/initiate`, token);
const getListAutomaticMessage = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/remark/default-message?page=${page}&limit=${limit}`, token);

// Escalation Ticket
const getInitiateEscalation = (escalationType, token) => Get(`/${nexcareVersion}/nexcare/remark/${escalationType}/initiate`, token);
const getListEscalation = (escalationType, page, limit, token) => Get(`/${nexcareVersion}/nexcare/remark/${escalationType}?page=${page}&limit=${limit}`, token);

// Closed Ticket
const getInitiateClosedTicket = (token) => Get(`/${nexcareVersion}/nexcare/remark/closed-ticket/initiate`, token);
const getListClosedTicket = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/remark/closed-ticket?page=${page}&limit=${limit}`, token);

const API_REMARK = {
    postDataRemark,
    putDataRemark,
    deleteDataRemark,
    getInitiateRootCause,
    getListRootCause,
    getInitiatePriority,
    getListPriority,
    getInitiateDocumentHeader,
    getListDocumentHeader,
    getInitiateKmsFeedback,
    getListKmsFeedback,
    getInitiateTicketFeedback,
    getListTicketFeedback,
    getInitiateChannelNote,
    getListChannelNote,
    getInitiateAutomaticMessage,
    getListAutomaticMessage,
    getInitiateEscalation,
    getListEscalation,
    getInitiateClosedTicket,
    getListClosedTicket
}

export default API_REMARK;